import {FeatureDefinition} from 'auth/feature-enablement/FeatureConstants';
import {getFeatureStatus} from 'auth/feature-enablement/FeatureStatus';
import * as BenchlingUtil from 'BenchlingUtil';
import {
  OverflowMenuActionFunction,
  ToolbarButtonActionFunction,
} from 'notebook/structured-tables/StructuredTableConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import makeSimpleActionFunction from './makeSimpleActionFunction';

interface OpenSchemaPageActionFunctionParams<TTableMetadata, TRowMetadata> {
  icon: BenchlingIconName;
  url: string | null;
  tooltip?: string | null;
  featureGate: FeatureDefinition;
}

/**
 * An ActionFunction that lets the user open the schema configuration page for a table.
 */
export function makeOpenSchemaPageActionFunction<TTableMetadata, TRowMetadata>(
  params: OpenSchemaPageActionFunctionParams<TTableMetadata, TRowMetadata>
): ToolbarButtonActionFunction<TTableMetadata, TRowMetadata> &
  OverflowMenuActionFunction<TTableMetadata, TRowMetadata> {
  return makeSimpleActionFunction({
    label: 'Open schema configuration',
    icon: params.icon,
    onInvoke: () => {
      BenchlingUtil.navigate(null, params.url!);
    },
    getTooltip: () => params.tooltip ?? `Opens the configuration page for this table's schema`,
    getHidden: () => params.url == null || !getFeatureStatus(params.featureGate).enabled,
  });
}
